import React from "react";

export default function Footer() {
  return (
    <footer 
      id="footer_area" 
      style={{ 
        textAlign: 'center',
        marginTop: 'auto',
        backgroundColor: '#f8f9fa',
      }}
    >
      <div className="container">
        <div className="row" style={{ alignItems: 'flex-start' }}>
          <div className="col-lg-4 col-md-4 col-sm-6 col-12">
            <div className="footer_inquery_area" style={{ marginBottom: '30px', padding: '0 15px', borderLeft: "none" }}>
              <h5 style={{ 
                color: '#495057', 
                fontSize: '16px',
                fontWeight: '600',
                letterSpacing: '0.5px'
              }}>
                Hotline
              </h5>
              <h3 style={{ margin: '0', fontSize: '24px', fontWeight: '700' }}>
                <a 
                  href="tel:0979969010" 
                  style={{ 
                    color: '#007bff', 
                    textDecoration: 'none',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#0056b3'}
                  onMouseOut={(e) => e.target.style.color = '#007bff'}
                >
                  0979 969 010
                </a>
              </h3>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6 col-12">
            <div className="footer_inquery_area" style={{ marginBottom: '30px', padding: '0 15px' }}>
              <h5 style={{ 
                color: '#495057', 
                fontSize: '16px',
                fontWeight: '600',
                letterSpacing: '0.5px'
              }}>
                Email
              </h5>
              <h3 style={{ margin: '0', fontSize: '20px', fontWeight: '700' }}>
                <a 
                  href="mailto:vemaybay@thanhhoang.vn" 
                  style={{ 
                    color: '#007bff', 
                    textDecoration: 'none',
                    wordBreak: 'break-word',
                    transition: 'color 0.3s ease'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#0056b3'}
                  onMouseOut={(e) => e.target.style.color = '#007bff'}
                >
                  vemaybay@thanhhoang.vn
                </a>
              </h3>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6 col-12">
            <div className="footer_inquery_area" style={{ marginBottom: '30px', padding: '0 15px' }}>
              <h5 style={{ 
                color: '#495057', 
                fontSize: '16px',
                fontWeight: '600',
                letterSpacing: '0.5px'
              }}>
                Theo dõi chúng tôi
              </h5>
              <ul className="soical_icon_footer" style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                gap: '20px', 
                listStyle: 'none', 
                padding: '0', 
                margin: '10px 0 0',
                flexWrap: 'wrap'
              }}>
                <li>
                  <a 
                    href="https://www.facebook.com/vemaybaygiarethanhhoang/" 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    style={{ 
                      color: '#3b5998',
                      transition: 'all 0.3s ease',
                      display: 'block'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.transform = 'scale(1.2)';
                      e.target.style.color = '#2d4373';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = 'scale(1)';
                      e.target.style.color = '#3b5998';
                    }}
                  >
                    <i className="fab fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a 
                    href="#" 
                    style={{ 
                      color: '#1da1f2',
                      transition: 'all 0.3s ease',
                      display: 'block'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.transform = 'scale(1.2)';
                      e.target.style.color = '#1991db';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = 'scale(1)';
                      e.target.style.color = '#1da1f2';
                    }}
                  >
                    <i className="fab fa-twitter-square"></i>
                  </a>
                </li>
                <li>
                  <a 
                    href="#" 
                    style={{ 
                      color: '#e1306c',
                      transition: 'all 0.3s ease',
                      display: 'block'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.transform = 'scale(1.2)';
                      e.target.style.color = '#c13584';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = 'scale(1)';
                      e.target.style.color = '#e1306c';
                    }}
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a 
                    href="#" 
                    style={{ 
                      color: '#0077b5',
                      transition: 'all 0.3s ease',
                      display: 'block'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.transform = 'scale(1.2)';
                      e.target.style.color = '#005885';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.transform = 'scale(1)';
                      e.target.style.color = '#0077b5';
                    }}
                  >
                    <i className="fab fa-linkedin"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
